import React from 'react';
import IconCheck from '../icon/icon-check';
import LabelEudrProducer from './label-eudr-prod';

const LabelEudr = ({ riesgo }) => LabelEudrProducer({ riesgo });

export default LabelEudr;
